exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#create-client-modal .client-form{transition:opacity .25s}#create-client-modal .client-form.processing{opacity:.15}", ""]);

